import React from "react";
import PropTypes from "prop-types";
import { Button } from "./Button";

import "./style.scss";

/**
 * ButtonControls:
 *   to render the button controls in settings
 */
export function ButtonControls(props) {
  const onClickIncrement = () => (!props.disabled ? props.increment() : null);
  const onClickDecrement = () => (!props.disabled ? props.decrement() : null);

  const onKeyPressIncrement = (event) => {
    if (props.disabled === false) {
      if (event.code == "Enter" || event.code == "Space") {
        onClickIncrement();
      }
    }
  };

  const onKeyPressDecrement = (event) => {
    if (props.disabled === false) {
      if (event.code == "Enter" || event.code == "Space") {
        onClickDecrement();
      }
    }
  };

  return (
    <div className="timer_settings_buttonControl">
      <Button
        onClick={onClickIncrement}
        onKeyPress={onKeyPressIncrement}
        disabled={props.disabled}
        altText={props.altText1}
      />
      <span className="timer_settings_buttonControl_text">{props.text}</span>
      <Button
        rotate={true}
        onClick={onClickDecrement}
        onKeyPress={onKeyPressDecrement}
        disabled={props.disabled}
        altText={props.altText2}
      />
    </div>
  );
}

ButtonControls.propTypes = {
  /**
   * callback to trigger on click of top button (increment button)
   */
  increment: PropTypes.func,
  /**
   * callback to trigger on click of bottom button (decrement button)
   */
  decrement: PropTypes.func,
  /**
   * text displayed between both buttons
   */
  text: PropTypes.string,
};

ButtonControls.defaultProps = {
  text: "",
};
